/**
 * Renders admin-authored content safely.
 * Handles both HTML content and plain text with line breaks.
 * If content contains HTML tags, renders as-is.
 * If content is plain text, converts newlines to paragraphs.
 */
export function prepareContent(raw) {
  if (!raw) return '';
  const trimmed = raw.trim();

  // Check if content already has HTML block-level tags
  const hasHtmlBlocks = /<(p|div|h[1-6]|ul|ol|li|table|blockquote|br|hr)\b/i.test(trimmed);

  if (hasHtmlBlocks) {
    return trimmed;
  }

  // Plain text: convert double newlines to paragraphs, single newlines to <br>
  const paragraphs = trimmed.split(/\n\s*\n/);
  return paragraphs
    .map(p => {
      const lines = p.trim().replace(/\n/g, '<br />');
      return lines ? `<p>${lines}</p>` : '';
    })
    .filter(Boolean)
    .join('\n');
}
